import { render, staticRenderFns } from "./AssignmentPreviewModal.vue?vue&type=template&id=596360a2&"
import script from "./AssignmentPreviewModal.vue?vue&type=script&lang=js&"
export * from "./AssignmentPreviewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports